import { Div } from "atomize"
import LessonsContainer from "../LessonsContainer"
import { isDesktopLike } from "../atoms/DesktopLikeView"
import { WEEK_GRID_BOTTOM_SPACE } from "../week/WeekGrid"
import useLessonLink from "../lesson/useLessonLink"

const Home = () => {
	// arrivati dal link di una lezione: la si apre
	useLessonLink()

	return (
		<Div id="home">
			<LessonsContainer />
			{/* sotto l'ultima lezione c'è posto per la barra; sul telefono
			    giorno / settimana sta nella fascia in cima */}
			<Div h={isDesktopLike ? `${WEEK_GRID_BOTTOM_SPACE}px` : "10rem"} pos="relative" />
		</Div>
	)
}

export default Home
